import actionTypes from "consts/actionTypes";

import { storeWeCareID, storeUserMaterials } from "actions/session";

export function getPendingCpe(weCareID) {
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        request: {
          method: "GET",
          url: `/mobistar/customer/public/${weCareID}/getPendingCpe/informat/json`,
        },
        onStart: () => {
          return {
            type: actionTypes.GET_PENDING_CPE_PENDING,
          };
        },
        onSuccess: (payload, meta, dispatch) => {
          dispatch(storeWeCareID(weCareID));
          dispatch(storeUserMaterials(payload.result));
          dispatch({
            type: actionTypes.GET_PENDING_CPE_SUCCESS,
            payload,
          });
          resolve(payload);
        },
        onError: (payload) => {
          resolve();
          return {
            type: actionTypes.GET_PENDING_CPE_ERROR,
            error: payload.error,
          };
        },
      });
    });
  }
}

export function activateCpe(weCareID, cpe) {
  let cpeParam = {};
  for (let i = 0; i < cpe.length; i++) {
    cpeParam[i] = {
      cpeSerial: cpe[i]["cpeSerial"],
      location: cpe[i]["location"],
    };
  }

  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        request: {
          method: "POST",
          url: `/mobistar/customer/public/${weCareID}/activateCpe/informat/json`,
          body: JSON.stringify({
            weCareID,
            cpe: cpeParam,
          }),
        },
        onStart: () => {
          return {
            type: actionTypes.POST_ACTIVATE_CPE_PENDING,
          };
        },
        onSuccess: (payload, meta, dispatch) => {
          dispatch({
            type: actionTypes.POST_ACTIVATE_CPE_SUCCESS,
            payload,
          });
          resolve(payload);
        },
        onError: (payload) => {
          resolve();
          return {
            type: actionTypes.POST_ACTIVATE_CPE_ERROR,
            error: payload.error,
          };
        },
      });
    });
  }
}

export function statusCpe(weCareID, cpe) {
  let cpeParam = {};
  for (let i = 0; i < cpe.length; i++) {
    cpeParam[i] = {
      cpeSerial: cpe[i]["cpeSerial"],
      location: cpe[i]["location"],
    };
  }

  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        request: {
          method: "POST",
          url: `/mobistar/customer/public/${weCareID}/statusCpe/informat/json`,
          body: JSON.stringify({
            weCareID,
            cpe: cpeParam,
          }),
        },
        onStart: () => {
          return {
            type: actionTypes.POST_STATUS_CPE_PENDING,
          };
        },
        onSuccess: (payload, meta, dispatch) => {
          dispatch({
            type: actionTypes.POST_STATUS_CPE_SUCCESS,
            payload,
          });
          resolve(payload);
        },
        onError: (payload) => {
          resolve();
          return {
            type: actionTypes.POST_STATUS_CPE_ERROR,
            error: payload.error,
          };
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/activations.js